// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RrDr","rootNoMargin":"styles_rootNoMargin__3HwMP"};